// A scene's terrain and edges are written together, through the joint step (settle.ts), so the one request carries
// whatever settling changed besides what the gesture did.
import { sameTerrain, type Terrain, terrainOf, terrainWrite } from "./cuts";
import { type Edges, edgesOf, edgesWrite, sameEdges } from "./edges";
import { settle } from "./settle";
import { terrainRows } from "./terrain";

type Stored = { terrain?: unknown; edges?: unknown };

// The terrain a scene holds, spelled as the server spells it.
export function sceneTerrain(terrain: unknown): Terrain {
	const { rows, cuts, corners, borders } = (terrain ?? {}) as { rows?: unknown; cuts?: string[]; corners?: string[]; borders?: string[] };
	return terrainOf(terrainRows({ rows }), cuts, corners, borders);
}

// The PATCH attributes and the local op that apply `terrain` and `edges` after settling them, each only where it
// differs from the scene's; null when neither does.
export function geometryWrite(scene: Stored, terrain: Terrain, edges: Edges) {
	const settled = settle(terrain, edges);
	const attrs: { terrain?: ReturnType<typeof terrainWrite>; edges?: ReturnType<typeof edgesWrite> } = {};
	const settledTerrain = sceneTerrain(settled.terrain);
	if (!sameTerrain(settledTerrain, sceneTerrain(scene.terrain))) attrs.terrain = terrainWrite(settledTerrain);
	if (!sameEdges(settled.edges, edgesOf(scene.edges))) attrs.edges = edgesWrite(settled.edges);
	if (!attrs.terrain && !attrs.edges) return null;
	return { attrs, local: attrs.edges ? { edges: settled.edges } : {} };
}
